module.exports = __webpack_public_path__ + "img/source.6860cf5e.png";